<template>
	<v-dialog max-width="600px" v-model="dialogModel">
		<v-card>
			<v-card-title class="headline">
				<span v-if="!isCreate">{{ $t("message.editCatalogue") }}</span>
				<span v-else>
					<Address></Address>
					{{ $t("message.addCatalogue") }}
				</span>
			</v-card-title>
			<v-card-text>
				<v-form ref="catalogueForm">
					<v-container grid-list-md pt-0>
						<v-layout row wrap>
							<v-flex md12 xs12>
								<v-text-field
									:label="$t('message.name')"
									prepend-icon="label"
									v-model="catalogueForm.name"
									:error-messages="errors.collect('catalogue')"
									data-vv-name="catalogue"
									v-validate="'required|max:30'"
								></v-text-field>
							</v-flex>
						</v-layout>
						<v-layout row wrap>
							<v-flex md12 xs12>
								<v-text-field
									:label="$t('message.description')"
									prepend-icon="zmdi-comment-more"
									v-model="catalogueForm.description"
									:error-messages="errors.collect('description')"
									data-vv-name="description"
									v-validate="'required|max:50'"
								></v-text-field>
							</v-flex>
							<v-flex xs12 v-if="!isCreate">
								<v-switch
									:label="
										catalogueForm.available
											? $t('message.enabled')
											: $t('message.disabled')
									"
									v-model="catalogueForm.available"
									color="primary"
									hide-details
								></v-switch>
								<v-text-field
									:label="$t('message.index')"
									prepend-icon="zmdi-sort-amount-desc"
									v-model="catalogueForm.index"
									:error-messages="errors.collect('index')"
									data-vv-name="index"
									v-validate="'required|numeric'"
									hint="Este valor permite ordenar tus catalogos de manera ascendente"
								></v-text-field>
							</v-flex>
						</v-layout>
					</v-container>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn outline @click="onClose" color="error" small>{{
					$t("message.close")
				}}</v-btn>
				<v-btn outline @click="onSave" color="primary" small>{{
					$t("message.save")
				}}</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: "manageCatalogue",
	props: {
		dialog: {
			required: false,
			default: false,
		},
		isCreate: {
			required: false,
			default: false,
		},
	},
	data() {
		return {
			catalogueForm: {
				name: "",
				description: "",
				available: true,
				valid: false,
				index: 1,
			},
			dialogModel: this.dialog,
		};
	},
	methods: {
		onClose() {
			this.$emit("update:dialog", false);
			this.catalogueForm.name = "";
			this.catalogueForm.description = "";
			this.$validator.reset();
		},
		async onSave() {
			try {
				const valid = await this.$validator.validateAll();

				if (valid) {
					this.$emit("on-save", {
						name: this.catalogueForm.name,
						description: this.catalogueForm.description,
						index: this.catalogueForm.index,
						available: this.catalogueForm.available,
					});

					this.onClose();
				}
			} catch (error) {
				console.error(error);
			}
		},
		setValue(catalogue) {
			this.catalogueForm.name = catalogue.name;
			this.catalogueForm.description = catalogue.description;
			this.catalogueForm.available = catalogue.available;
			this.catalogueForm.index = catalogue.index;
		},
	},
	watch: {
		dialog(value) {
			this.dialogModel = value;
		},
		dialogModel(value) {
			this.$emit("update:dialog", value);
		},
	},
};
</script>

<style></style>
